export default __webpack_public_path__ + "static/media/logo.274b0b2e.png";